<template>
  <div>
    <div style="width: 100%;height: 32px;"></div>
    <el-form :model="ruleForm" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
      <el-form-item label="配送地址：" prop="goodsPriceDesc">
        <el-cascader
          style="width: 424px;"
          v-model="addressIds"
          :options="addressList"
          :props="{ value: 'value',label: 'text',children: 'children'}"
          @change="handleChange"></el-cascader>
      </el-form-item>
      <el-form-item label="商品价格说明：" prop="goodsPriceDesc">
        <editor :height="350" v-model="ruleForm.goodsPriceDesc"></editor>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { saveOrUpdateShopConfig, fetchShopConfigDetail, queryAreaTreeList } from '@/api/shop'
export default {
  name: 'GoodsExplain',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fullscreenLoading: false,
      addressList:[],
      addressIds:[],
      ruleForm: {
        goodsPriceDesc:''
      }
    }
  },
  mounted () {
    var that = this;
    queryAreaTreeList({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.addressList = data;
        }
    })
    fetchShopConfigDetail({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.ruleForm = data;
          // 配送地址
          that.addressIds = [data.deliveryProvinceId,data.deliveryCityId,data.deliveryDistrictId];
        }
    })
  },
  methods: {
    handleChange(value) {
      console.log(value);
    },
    // 保存操作
    saveBtn () {
      let that = this
      let addressIds = that.addressIds;
      if(addressIds.length == 0){
        this.$message.error('请选择配送地址')
        return false;
      }
      let deliveryProvinceId = addressIds[0]
      let deliveryCityId = addressIds[1]
      let deliveryDistrictId = addressIds[2]
      let goodsPriceDesc = that.ruleForm.goodsPriceDesc
      that.fullscreenLoading = true
      saveOrUpdateShopConfig({goodsPriceDesc:goodsPriceDesc,deliveryProvinceId:deliveryProvinceId,deliveryCityId:deliveryCityId,deliveryDistrictId:deliveryDistrictId}).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.$router.go(0)
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/components/GoodsExplain.vue